import { setupBugsink } from '@common/utils/bugsink.js';
import { config } from '@src/config/index.js'; // eslint-disable-line import/order -- "Why? There is now line break here"

setupBugsink({
  dsns: config.bugsinkDsns,
  version: _MFE_VERSION, // Filled/replaced by esbuild (see scripts/esbuild/*.ts)config.version,
});

import { configure } from 'mobx';  // eslint-disable-line -- import only after bugsink init
import { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';  // eslint-disable-line --  import only after bugsink init

configure({
  isolateGlobalState: true,
});

window.customElements.define('tef-coms4cs', TefComs4csMicroFrontend);

// 22.04.2024 force rebuild
